export const THEMES = {
  DARK: 'DARK'
};

export const ENABLE_REDUX_DEV_TOOLS = true;
